<div class="checkbox-wrapper"
     [ngClass]="{checked: value, disabled: disable}"
     [class.error]="(control.touched && control.invalid)"
>
  <input [id]="formControlName || id"
         [(ngModel)]="value || checked"
         [disabled]="disable"
         [tabindex]="tabInd"
         type="checkbox"
         [checked]="checked"
         (change)="onChanged($event)"
         (blur)="blurred($event)"
         (keydown.Enter)="onEnterKeyPress()"
         (keydown.Tab)="keydownTab.emit($event)"
         (focus)="onFocus()"
         (focusout)="onFocusOut()"
         [class.checked-alternative-style]="checkedAlternativeStyle"
         tabindex="0"
         #checkBox
  />

  <label [class.disabled]="disable" *ngIf="label" [for]="formControlName || id" (click)="$event.preventDefault()">
    {{label}}
  </label>
  <label [class.disabled]="disable" [for]="formControlName || id">
    <ng-content></ng-content>
  </label>
</div>
